import { InputHTMLAttributes, forwardRef } from 'react'

import { StyledInput as S } from './Input.styles'

type TProps = InputHTMLAttributes<HTMLInputElement> & {
  isValid?: boolean
  labelText?: string
  validationText?: string
  inputHeight?: number
  marginBottom?: number
}

export const Input = forwardRef<HTMLInputElement, TProps>(
  (
    {
      isValid = true,
      labelText,
      validationText = '',
      type = 'text',
      inputHeight = 56,
      marginBottom = 24,
      dir = 'ltr',
      ...props
    },
    ref,
  ) => (
    <S.Wrapper
      marginBottom={marginBottom}
      data-valid={isValid}
      data-validation-text={validationText}
    >
      {!!labelText && <S.Label>{labelText}</S.Label>}
      <S.Input
        type={type}
        inputHeight={inputHeight}
        dir={dir}
        ref={ref}
        {...props}
      />
    </S.Wrapper>
  ),
)
